import { setSpecificMessage, isoTimestamp } from "valibot";
setSpecificMessage(
  isoTimestamp,
  (issue) => `Timestamp invalide: reçu ${issue.received}`,
  "fr"
);